import React, { useEffect, useState } from "react";
import { Button, Card, Col, Form, Modal, Row } from "react-bootstrap";
import * as Icon from "react-bootstrap-icons";
import CreatePlannerModal from "./Modal/CreatePlannerModal";
import ViewPlannerModal from "./Modal/ViewPlannerModal";
import axios from "axios";
import { toast } from "react-toastify";
import { useSelector } from "react-redux";
import AssignConfirmationModal from "./Modal/AssignConfirmationModal";

const Planner = () => {
    const userState = useSelector((state) => state.loginData.userData);
    const [plannerList, setPlannerList] = useState([]);
    const [showPlannerModal, setShowPlannerModal] = useState(false);
    const [showViewModal, setShowViewModal] = useState(false);
    const [selectedPlanner, setSelectedPlanner] = useState(null);
    const [isEdit, setIsEdit] = useState(false);
    const [loading, setLoading] = useState(false);
    const [showAssignConfirm, setShowAssignConfirm] = useState(false);
    const [showCloneModal, setShowCloneModal] = useState(false);
    const [plannerName, setPlannerName] = useState("");
    const [selectedClonePlanner, setSelectedClonePlanner] = useState(null);

    useEffect(() => {
        getAllPlanner();
    }, []);

    // get all planner
    const getAllPlanner = async () => {
        const payload = {
            assignBy_id: userState?.empId
        }
        try {
            setLoading(true);
            const res = await axios.post(process.env.REACT_APP_BASE_URL + "/planner/getAllPlanner", payload);
            setPlannerList(res?.data?.data || []);
        } catch (err) {
            console.log("get planner error", err);
        } finally {
            setLoading(false);
        }
    };

    // for clone planner
    const handleClonePlanner = async () => {
        if (!plannerName?.trim()) {
            toast.error("Please Enter Planner Name");
            return;
        }

        try {
            const payload = {
                planeGroupId: selectedClonePlanner?.planeGroupId,
                plannerName: plannerName
            };

            await axios.post(
                process.env.REACT_APP_BASE_URL + "/planner/clonePlanner",
                payload
            );

            toast.success("Planner Cloned Successfully");

            setShowCloneModal(false);
            setPlannerName("");
            setSelectedClonePlanner(null);
            getAllPlanner();

        } catch (err) {
            console.log("clone planner error", err);
            toast.error("Failed to clone planner");
        }
    };

    // for handler assign planner to user
    const handleAssignPlanner = async (item) => {
        try {
            const payload = {
                taskList: item?.taskList?.map((task) => ({
                    planTaskId: task?.planTaskId,
                    planeGroupId: task?.planeGroupId,
                    taskTitle: task?.taskTitle,
                    taskDescription: task?.taskDescription,
                    startDate: task?.startDate,
                    endDate: task?.endDate,
                    estimatedHours: task?.estimatedHours,
                    estimatedMinutes: task?.estimatedMinutes,
                    assignTo: task?.assignTo,
                    assignToName: task?.assignToName,
                    projectId: task?.projectId,
                    projectName: task?.projectName,
                    assignBy_id: task?.assignBy_id,
                    assignBy_Name: task?.assignBy_Name
                })),
            };

            const res = await axios.post(process.env.REACT_APP_BASE_URL + "/task/AddBulkTask", payload);
            toast.success("Planner Assigned Successfully");
            setShowViewModal(false);
            setSelectedPlanner(null);
            getAllPlanner();

        } catch (err) {
            console.log("assign error", err);
        }
    };

    return (
        <div className="AssignTask outletPadding" data-aos="fade-up">
            {
                showPlannerModal &&
                <CreatePlannerModal
                    show={showPlannerModal}
                    close={() => {
                        setShowPlannerModal(false);
                        setSelectedPlanner(null);
                        setIsEdit(false);
                    }}
                    editData={selectedPlanner}
                    isEdit={isEdit}
                    getAllPlanner={getAllPlanner}
                />
            }
            <ViewPlannerModal
                show={showViewModal}
                close={() => setShowViewModal(false)}
                item={selectedPlanner}
                getAllPlanner={getAllPlanner}
                handleAssignPlanner={handleAssignPlanner}
            />

            <AssignConfirmationModal
                show={showAssignConfirm}
                close={() => setShowAssignConfirm(false)}
                onConfirm={async () => {
                    await handleAssignPlanner(selectedPlanner);
                    setShowAssignConfirm(false);
                }}
            />

            {/* top button */}
            <div className="d-flex justify-content-end mb-4">

                <Button
                    className="activeBtn"
                    onClick={() => {
                        setSelectedPlanner(null);
                        setIsEdit(false);
                        setShowPlannerModal(true);
                    }}
                >
                    <Icon.PlusCircle className="me-2" />
                    Add Planner
                </Button>

            </div>

            {/* planner cards */}
            {
                loading ? (
                    <div
                        className="d-flex justify-content-center align-items-center"
                        style={{ minHeight: "60vh" }}
                    >
                        <div className="spinner-border text-primary" role="status">
                            <span className="visually-hidden">
                                Loading...
                            </span>
                        </div>
                    </div>
                ) : (
                    <Row className="mt-4">
                        {
                            plannerList?.map((item, index) => {
                                const firstTask = item?.taskList?.[0];
                                return (
                                    <Col lg={4} md={6} sm={12} key={index}>
                                        <Card
                                            className="border-0 shadow-sm mb-4"
                                            style={{
                                                borderRadius: "18px",
                                                overflow: "hidden",
                                                background: "#fff",
                                                transition: "0.3s ease",
                                            }}
                                        >
                                            <Card.Body>
                                                <div className="d-flex justify-content-between align-items-start">
                                                    <div>
                                                        <h5
                                                            className="fw-bold mb-2"
                                                            style={{
                                                                color: "#203759"
                                                            }}
                                                        >
                                                            {item?.plannerName}
                                                        </h5>

                                                    </div>

                                                    {/* icons */}
                                                    <div
                                                        className="d-flex align-items-center"
                                                        style={{
                                                            gap: "12px",
                                                            flexShrink: 0,
                                                        }}
                                                    >
                                                        {/* <Icon.Eye
                                                            size={18}
                                                            color="#203759"
                                                            title="View Planner"
                                                            onClick={() => {
                                                                setSelectedPlanner(item);
                                                                setShowViewModal(true);
                                                            }}
                                                            style={{ cursor: "pointer" }}
                                                        /> */}

                                                        <Icon.Pencil
                                                            size={18}
                                                            color="#47AB64"
                                                            title="Edit Planner"
                                                            onClick={() => {
                                                                setSelectedPlanner(item);
                                                                setIsEdit(true);
                                                                setShowPlannerModal(true);
                                                            }}
                                                            style={{ cursor: "pointer" }}
                                                        />

                                                        {/* <Icon.PersonCheck
                                                            size={18}
                                                            color="#8E44AD"
                                                            title="Assign Planner"
                                                            onClick={() => {
                                                                setSelectedPlanner(item);
                                                                setShowAssignConfirm(true);
                                                            }}
                                                            style={{ cursor: "pointer" }}
                                                        /> */}

                                                        <Icon.Files
                                                            size={18}
                                                            color="#0D6EFD"
                                                            title="Clone Planner"
                                                            onClick={() => {
                                                                setSelectedClonePlanner(item);
                                                                setPlannerName(`${item?.plannerName} Copy`);
                                                                setShowCloneModal(true);
                                                            }}
                                                            style={{ cursor: "pointer" }}
                                                        />
                                                    </div>
                                                </div>

                                                {/* bottom */}
                                                <div className="mt-4">
                                                    {/* start date */}
                                                    <div className="d-flex justify-content-between mb-2">
                                                        <span className="fw-semibold">
                                                            Start Date
                                                        </span>
                                                        <span>
                                                            {firstTask?.startDate}
                                                        </span>
                                                    </div>

                                                    {/* end date */}
                                                    <div className="d-flex justify-content-between mb-2">
                                                        <span className="fw-semibold">
                                                            End Date
                                                        </span>
                                                        <span>
                                                            {firstTask?.endDate}
                                                        </span>
                                                    </div>

                                                    {/* estimate */}
                                                    {/* <div className="d-flex justify-content-between mb-2">
                                                        <span className="fw-semibold">
                                                            Estimate Time
                                                        </span>
                                                        <span>
                                                            {firstTask?.estimatedHours}h{" "}
                                                            {firstTask?.estimatedMinutes}m
                                                        </span>
                                                    </div> */}
                                                </div>
                                                <div className="mt-4 d-flex gap-2 justify-content-end">
                                                    <Button
                                                        variant="outline-primary"
                                                        style={{ minWidth: "100px" }}
                                                        onClick={() => {
                                                            setSelectedPlanner(item);
                                                            setShowViewModal(true);
                                                        }}
                                                    >
                                                        <Icon.Eye className="me-2" />
                                                        View
                                                    </Button>

                                                    <Button
                                                        className="activeBtn"
                                                        style={{ minWidth: "100px" }}
                                                        onClick={() => {
                                                            setSelectedPlanner(item);
                                                            setShowAssignConfirm(true);
                                                        }}
                                                    >
                                                        <Icon.PersonCheck className="me-2" />
                                                        Assign
                                                    </Button>
                                                </div>
                                            </Card.Body>
                                        </Card>
                                    </Col>
                                );
                            })
                        }

                    </Row>
                )
            }

            <Modal
                show={showCloneModal}
                onHide={() => setShowCloneModal(false)}
                centered
            >
                <Modal.Header closeButton>
                    <Modal.Title>
                        Enter Planner Name
                    </Modal.Title>
                </Modal.Header>

                <Modal.Body>

                    <Form.Group>
                        <Form.Label>
                            Planner Name
                        </Form.Label>

                        <Form.Control
                            as="textarea"
                            rows={3}
                            placeholder="Enter Planner Name"
                            value={plannerName}
                            onChange={(e) =>
                                setPlannerName(e.target.value)
                            }
                        />
                    </Form.Group>

                </Modal.Body>

                <Modal.Footer>

                    <Button
                        variant="secondary"
                        onClick={() => {
                            setShowCloneModal(false);
                            setPlannerName("");
                        }}
                    >
                        Cancel
                    </Button>

                    <Button
                        className="activeBtn"
                        onClick={handleClonePlanner}
                    >
                        Proceed
                    </Button>

                </Modal.Footer>
            </Modal>
        </div>




    );
};

export default Planner;